export default __webpack_public_path__ + "a3957a09fd6b369f0786ca39b89afa6e.png";